const pageLayout = {
	common: [
		{
			component: 'seoInfoBlock',
		},
		{
			component: 'packageCards',
			config: {
				start: 0,
				count: 15,
			},
		},
		{
			component: 'departureCityInterlinkingCards',
		},
		{
			component: 'packageCards',
			config: {
				start: 15,
				count: 15,
			},
		},
		{
			component: 'mediaComponents',
		},
		{
			component: 'themedDestinationInterlinkingCards',
		},
		{
			component: 'byCitiesInterlinkingCards',
		},
		{
			component: 'customerTestimonials',
		},
		{
			component: 'faq',
		},
		{
			component: 'destinationPills',
		},
	],
}

export default pageLayout
